
/**
 * Sources
 *
 * https://www.philosophybasics.com/general_quotes.html
 * http://www.quotegarden.com/philosophical.html
 */
Game.JSON.quotes = [
	'Whereof one cannot speak, thereof one must be silent',
	'I think therefore I am',
	'One cannot step twice in the same river',
	'To be is to be perceived',
	'Liberty consists in doing what one desires',
	'Even while they teach, one learns',
	'Leisure is the mother of philosophy',
	'Happiness is the highest good',
	'The only thing I know is that I know nothing',
	'In everything, there is a share of everything',
	'We are too weak to discover the truth by reason alone',
	'Believe those who are seeking the truth; doubt those who find it',
	'Losing an illusion makes you wiser than finding a truth',
	'When the student is ready, the master appears',
	'If you think you are free, there is no escape possible',
	'Do not miss the donut by looking through the hole',
	'You can not wake a person who is pretending to be asleep',
	'To learn something new, take the path that you took yesterday',
	'The obstacle is the path',
	'It is easy to stand a pain, but difficult to stand an itch',
	'You exist in time, but you belong to eternity',
	'Tomorrow always comes, and today is never yesterday',
	'The tighter you squeeze, the less you have',
	'It is always Now',
	'There are more lines formed than things worth waiting for',
	'To believe with certainty we must begin with doubting',
];
